<template>
  <!-- 盒子/饰品升级-用户数据（升级） -->
  <div class="upgrade_userData-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.user_id" placeholder="请输入用户id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.origin_name" placeholder="请输入盒子名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.origin_id" placeholder="请输入盒子id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker style="width: 200px" v-model="query.start_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
          —
          <el-date-picker style="width: 200px" v-model="query.end_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getData(1)">确定</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="origin_id" label="盒子id" align="center">
        </el-table-column>
        <el-table-column prop="origin_name" label="盒子名称" align="center">
        </el-table-column>
        <el-table-column prop="boxUpgradeNums" label="盒子升级次数" align="center">
        </el-table-column>
        <el-table-column prop="boxWinPro" label="升级成功率" align="center">
        </el-table-column>
        <el-table-column prop="user_name" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="user_id" label="用户uid" align="center">
        </el-table-column>
        <el-table-column prop="userUpgradeNums" label="用户升级次数" align="center">
        </el-table-column>
        <el-table-column prop="userWinPro" label="用户升级成功率" align="center">
        </el-table-column>
        <el-table-column prop="userUpgradeCostTotalAmount" label="升级消耗" align="center">
        </el-table-column>
        <el-table-column prop="userPrizeAmount" label="奖品金额" align="center">
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {
        page: 1,
        user_id: '',
        origin_name: undefined,
        origin_id: undefined,
        start_time: undefined,
        end_time: undefined,
      },
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData(1)
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('upgrade_user_data', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    handleExport() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.query

      http
        .post(
          api + 'upgrade_info_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '升级用户数据.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }

}
</script>
<style lang="less" scoped>
.upgrade_userData-box {
  header {}

  .body-box {
    // width: 800px;
  }
}
</style>